import { Link, useSearchParams } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  const [params] = useSearchParams();
  const bookingId = params.get("booking_id");
  return (
    <div className="pt-32 pb-16 max-w-2xl mx-auto px-4 text-center" data-testid="payment-cancel-page">
      <XCircle className="w-12 h-12 text-rose-600 mx-auto" />
      <h1 className="mt-6 text-3xl font-bold text-slate-900">Payment cancelled</h1>
      <p className="mt-2 text-slate-600">
        No worries — your booking is still saved. You can complete parts payment when ready.
      </p>
      {bookingId && (
        <Link
          to={`/checkout/${bookingId}`}
          className="mt-6 inline-flex items-center gap-2 px-6 py-3 rounded-xl bg-slate-900 text-white font-semibold hover:bg-slate-800"
        >
          Back to checkout
        </Link>
      )}
    </div>
  );
}
